import { useEffect, useState } from "react";
import { apiPaths } from "../../service/apiPaths";
import ApiService from "../../service/ApiService";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FormData } from "./Notification";

const useNotification = () => {
      const [loading, setLoading] = useState<boolean>(false);
      const [courses, setCourses] = useState<any[]>([]);
      const [languages, setLanguages] = useState<any[]>([]);
      const [subjectName, setSubjectName] = useState<any[]>([]);
      const isPhyiscalBookAvailable = [{isPhysicalBookAvailable:'Available'},{isPhysicalBookAvailable:'NA'}]
      const [standard, setStandard] = useState<any[]>([]);
      const navigate = useNavigate();


    const sendBrodcastNotification = async ({title , body , standard , courseName , sendToAll}:FormData) => {
        try {
            const data = await ApiService({
                method: "POST",
                endpoint: apiPaths.sendNotification,
                data: { title, body  , standard , courseName , sendToAll},
            });

            return data;
        } catch (error) {
            return null;
        }
    };




    const fetchStandardAndCourse = async () => {
        try {
          setLoading(true);
          const [
            coursesResponse,
       
            standardResponse,
          ] = await Promise.all([
            ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
            ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
          ]);
          // setLanguages(languagesResponse);
          console.log("SUbject Response : ",coursesResponse)
            let course = coursesResponse.map((item: any) =>{return {standard:item.standard , courseName: item.courseName}});
            let standard = standardResponse.map((item: any) => item.standard);

            // setLanguages(languagesResponse);
          // setSubjectName(subjectResponse);
          setStandard(standard);
          setCourses(course);
    
        } catch (error) {
          console.error("Error fetching courses and languages:", error);
          toast.error("Failed to fetch courses or languages.");
        } finally {
          setLoading(false);
        }
      };
    

    return { sendBrodcastNotification , standard,  courses, fetchStandardAndCourse, isPhyiscalBookAvailable, loading , setCourses };    
};

export default useNotification;
